import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import Box from '../Box';
import styles from './styles.module.css';

const Grid = ({ children, columns, condensed }: any) => {
  const classnames = cnames(styles.grid, {
    [styles.condensed]: condensed,
  });

  if (!children) return null;

  return (
    <Box
      className={classnames}
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {children}
    </Box>
  );
};

(Grid as any).displayName = 'Grid';

(Grid as any).propTypes = {
  /**
    * Items to be display in the grid
    */
  children: PropTypes.node.isRequired,
  /**
    * The number of columns in the grid
    */
  columns: PropTypes.number,
  /**
    * When true, items in the grid are closer to one another
    */
  condensed: PropTypes.number,
};

(Grid as any).defaultProps = {
  columns: 4,
};

export default Grid;
